import React from 'react';
import '../../cards.css';
import { navigate } from 'gatsby';
import { Badge, Label } from '@nooz-optics/nooz-components-lib';
import { Image } from '../../../Media/Image/index';
import {
  IBlogArticle,
  IButton,
  IImage,
} from '../../../../../utils/types/contentful';
import { returnLocalisedPath } from '../../../../../utils/globals';
import { withLocale } from '../../../../../utils/hocs';
import { Button } from '../../../Elements';

export interface BlogArticleLinkCardProps {
  badges?: any;
  article: IBlogArticle;
  image: IImage;
  locale: any;
  button: IButton;
}

export const BlogArticleLinkCard = withLocale(
  ({
    badges,
    article,
    image,
    locale,
    button,
  }: BlogArticleHightlightCardProps) => (
    <div className='cards w-full h-full relative border-b'>
      <div className='absolute top-0 h-full w-full' />
      <div
        className='absolute bg-opacity-0 h-full w-full bg-black backdrop-filter'
        aria-hidden='true'
      />
      <div className='absolute w-full p-7 lg:p-9 bottom-0'>
        <div className='relative'>
          {badges && (
            <div className='flex'>
              {badges?.items?.map((badge) => (
                <div className='mb-2 mr-2'>
                  <Badge {...badge} />
                </div>
              ))}
            </div>
          )}
          <div className='mb-2 flex w-full justify-between'>
            <Label
              {...article.label}
              size='4xl'
              weight='bold'
            />
          </div>
          {article.subLabel && (
            <div className='mb-2'>
              <Label
                {...article.subLabel}
                size='base'
              />
            </div>
          )}
          <div className='mt-4'>
            <Button
              onClick={() =>
                navigate(returnLocalisedPath(locale[0], button.slug.url))
              }
              {...button}
              type='contained'
              size='base'
            />
          </div>
        </div>
      </div>
      <div className='w-full h-full bg-gray-200'>
        <Image
          {...image}
          objectFit='cover'
          height='100%'
          width='100%'
        />
      </div>
    </div>
  )
);
